"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const LOADER_OBJECTS = [{
  emoji: '🚀',
  label: 'rocket'
}, {
  emoji: '✈️',
  label: 'airplane'
}, {
  emoji: '🏐',
  label: 'volleyball'
}, {
  emoji: '🎈',
  label: 'balloon'
}, {
  emoji: '🎁',
  label: 'gift'
}];
const STEP_MS = 12000;
const VOLLEYBALL_SIZE_PX = 56;
const VOLLEYBALL_FLOOR_OFFSET_PX = 28;
const VOLLEYBALL_SPIN_MULTIPLIER = 0.45;
const VOLLEYBALL_HORIZONTAL_SPEED_PX_PER_S = 122;
const VOLLEYBALL_EXIT_BUFFER_MS = 20;
function FunLoader({
  title = 'Preparing your next adventure...',
  subtitle = 'Finding the best videos for you',
  ariaLabel = 'Loading'
}) {
  const objects = (0, _react.useMemo)(() => [...LOADER_OBJECTS].sort(() => Math.random() - 0.5), []);
  const [activeIndex, setActiveIndex] = (0, _react.useState)(0);
  const loaderRef = (0, _react.useRef)(null);
  const volleyballSceneRef = (0, _react.useRef)(null);
  const [volleyballPose, setVolleyballPose] = (0, _react.useState)({
    x: -VOLLEYBALL_SIZE_PX,
    y: 0,
    rotation: 0
  });
  const activeObject = objects[activeIndex];
  const displayedObject = activeObject;
  const isDirectional = displayedObject.label === 'rocket' || displayedObject.label === 'airplane';
  const isVolleyball = displayedObject.label === 'volleyball';
  const flightOffset = displayedObject.label === 'rocket' ? '28deg' : '34deg';
  const volleyballStyle = isVolleyball ? {
    '--volleyball-x': `${volleyballPose.x}px`,
    '--volleyball-y': `${volleyballPose.y}px`,
    '--volleyball-rotation': `${volleyballPose.rotation}deg`
  } : undefined;
  (0, _react.useEffect)(() => {
    const isVolleyballTurn = displayedObject.label === 'volleyball';
    const loaderWidth = loaderRef.current?.clientWidth ?? 0;
    const volleyballTravelMs = loaderWidth > 0 ? (loaderWidth + 2 * VOLLEYBALL_SIZE_PX) / VOLLEYBALL_HORIZONTAL_SPEED_PX_PER_S * 1000 : STEP_MS;
    const stepDurationMs = isVolleyballTurn ? Math.ceil(volleyballTravelMs + VOLLEYBALL_EXIT_BUFFER_MS) : STEP_MS;
    const timer = setTimeout(() => {
      setActiveIndex(prev => (prev + 1) % objects.length);
    }, stepDurationMs);
    return () => clearTimeout(timer);
  }, [activeIndex, displayedObject.label, objects.length]);
  (0, _react.useEffect)(() => {
    if (!isVolleyball) {
      return undefined;
    }
    let frameId;
    let previousTs;
    let x = -VOLLEYBALL_SIZE_PX;
    let y = 0;
    const vx = VOLLEYBALL_HORIZONTAL_SPEED_PX_PER_S;
    const bounceLaunchVelocity = -690;
    let vy = bounceLaunchVelocity;
    let rotation = 0;
    const gravity = 2200;
    const frame = ts => {
      const scene = volleyballSceneRef.current;
      if (!scene) {
        frameId = requestAnimationFrame(frame);
        return;
      }
      const width = scene.clientWidth;
      const height = scene.clientHeight;
      const floorY = Math.max(0, height - VOLLEYBALL_SIZE_PX - VOLLEYBALL_FLOOR_OFFSET_PX);
      if (previousTs === undefined) {
        previousTs = ts;
        y = floorY;
      }
      const dt = Math.min((ts - previousTs) / 1000, 0.034);
      previousTs = ts;
      x += vx * dt;
      vy += gravity * dt;
      y += vy * dt;
      if (y >= floorY) {
        y = floorY;
        vy = bounceLaunchVelocity;
      }
      if (x > width + VOLLEYBALL_SIZE_PX) {
        x = -VOLLEYBALL_SIZE_PX;
        y = floorY;
        vy = bounceLaunchVelocity;
      }
      rotation += vx * dt / VOLLEYBALL_SIZE_PX * 360 * VOLLEYBALL_SPIN_MULTIPLIER;
      setVolleyballPose({
        x,
        y,
        rotation
      });
      frameId = requestAnimationFrame(frame);
    };
    frameId = requestAnimationFrame(frame);
    return () => cancelAnimationFrame(frameId);
  }, [isVolleyball, activeIndex]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: loaderRef,
    className: "fun-feed-loader",
    "aria-live": "polite",
    "aria-label": ariaLabel,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "fun-feed-loader__title",
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "fun-feed-loader__subtitle",
      children: subtitle
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ref: isVolleyball ? volleyballSceneRef : null,
      className: `fun-feed-loader__solo-object ${isVolleyball ? 'fun-feed-loader__solo-object--volleyball' : ''}`,
      style: volleyballStyle,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: `fun-feed-loader__glyph-wrap ${isVolleyball ? 'fun-feed-loader__glyph-wrap--static' : ''}`,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: `fun-feed-loader__glyph ${isDirectional ? 'fun-feed-loader__glyph--directional' : ''} ${isVolleyball ? 'fun-feed-loader__glyph--volleyball' : ''}`,
          role: "img",
          "aria-label": displayedObject.label,
          style: isDirectional ? {
            '--flight-offset': flightOffset
          } : undefined,
          children: displayedObject.emoji
        })
      })
    }, `${displayedObject.label}-${activeIndex}`)]
  });
}
var _default = exports.default = FunLoader;